var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D2AFB5EC-BB88-40CF-AE62-A9CB97788207") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---New-menu-and-order-pages-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Favourites",
    transform: "translate(-373, -621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(321, 607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(52, 14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,17.8666667 L9.46666667,24.4 C9.22222667,24.6445333 8.91110667,24.7666667 8.53333333,24.7666667 C8.15556,24.7666667 7.84444,24.6445333 7.6,24.4 C7.35556,24.1556 7.23333333,23.8445333 7.23333333,23.4666667 C7.23333333,23.0889333 7.35556,22.7778667 7.6,22.5333333 L14.1333333,16 L7.6,9.46673333 C7.35556,9.22229333 7.23333333,8.91117333 7.23333333,8.5334 C7.23333333,8.15562667 7.35556,7.84450667 7.6,7.60006667 C7.84444,7.35562667 8.15556,7.2334 8.53333333,7.2334 C8.91110667,7.2334 9.22222667,7.35562667 9.46666667,7.60006667 L16,14.1333333 L22.5333333,7.60006667 C22.7777333,7.35562667 23.0889333,7.2334 23.4666667,7.2334 C23.8444,7.2334 24.1556,7.35562667 24.4,7.60006667 C24.6444,7.84450667 24.7666667,8.15562667 24.7666667,8.5334 C24.7666667,8.91117333 24.6444,9.22229333 24.4,9.46673333 L17.8666667,16 L24.4,22.5333333 C24.6444,22.7778667 24.7666667,23.0889333 24.7666667,23.4666667 C24.7666667,23.8445333 24.6444,24.1556 24.4,24.4 C24.1556,24.6445333 23.8444,24.7666667 23.4666667,24.7666667 C23.0889333,24.7666667 22.7777333,24.6445333 22.5333333,24.4 L16,17.8666667 Z",
    id: "Path",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTeal);
export default __webpack_public_path__ + "static/media/close-teal.a90392da7774a89909c9a24e7f0407e6.svg";
export { ForwardRef as ReactComponent };